import React from 'react';
import PropTypes from 'prop-types';
import UserAvatar from '../Global/Avatars/UserAvatar';
import VerticalTextLockup from '../Global/Typography/VerticalTextLockup';

const SearchUserTeaser = ({ image, name, summary, slug, verified }) => (
  <a href={slug} className="card-link d-flex">
    <div className="m-r-2 flex-shrink-0">
      <UserAvatar image={image} size="l" verified={verified} />
    </div>
    <div className="d-flex align-items-center">
      <VerticalTextLockup
        title={<h3 className="card-link__text-change like-h5">{name}</h3>}
        subtitle={<p className="like-small">{summary}</p>}
      />
    </div>
  </a>
);

SearchUserTeaser.propTypes = {
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  summary: PropTypes.string,
  slug: PropTypes.string.isRequired,
  verified: PropTypes.bool,
};

export default SearchUserTeaser;



// WEBPACK FOOTER //
// ./library/app/components/Search/SearchUserTeaser.js